// qr.js — v4.1 : QR code pour ajouter/vérifier un contact sans comparer un
// long fingerprint hexadécimal à la main. Le QR encode uniquement le pseudo
// et la clé publique (déjà publics par nature, distribués par l'annuaire
// serveur) — aucune nouvelle métadonnée, rien de secret n'y transite jamais.
// Génération et lecture 100 % locales (bibliothèque bundlée, pas de service
// tiers ; lecture via l'API native BarcodeDetector du navigateur).
const PREFIX = 'msgring1:';

export function qrPayload(pseudo, publicKeyB64) {
  return `${PREFIX}${pseudo}:${publicKeyB64}`;
}

export function parseQrPayload(text) {
  if (typeof text !== 'string' || !text.startsWith(PREFIX)) return null;
  const rest = text.slice(PREFIX.length);
  const i = rest.indexOf(':');
  if (i < 0) return null;
  const pseudo = rest.slice(0, i);
  const publicKey = rest.slice(i + 1);
  if (!pseudo || !publicKey) return null;
  return { pseudo, publicKey };
}

export function isScanSupported() {
  // v4.3 : le scan ne dépend plus de BarcodeDetector (absent de Safari iOS,
  // de Firefox…) — un décodeur bundlé (jsqr, 100 % local) prend le relais.
  // Seul prérequis restant : l'accès caméra.
  return typeof navigator !== 'undefined' && !!navigator.mediaDevices?.getUserMedia;
}

export function hasNativeDetector() {
  return typeof window !== 'undefined' && 'BarcodeDetector' in window;
}
